import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import Layout from '../components/Layout';
import { useCallback, useEffect, useRef, useState } from 'react';
import Gallery from '../components/gallery/Gallery';
import CategoryCard from '../components/card/categoryCard/CategoryCard';
import styles from './index.module.scss';
import scrollIntoView from 'scroll-into-view-if-needed';
import ScrollTop from '../components/scrollTop/ScrollTop';
import useDebouncedMemo from '../lib/utils/useDebouncedMemo';
var Home = function(param) {
    var categories = param.categories, images = param.images, groups = param.groups;
    var containerRef = useRef(null);
    var ref3 = useState(''), query = ref3[0], setQuery = ref3[1];
    var ref1 = useState(categories[0]), selectedCategory = ref1[0], setSelectedCategory = ref1[1];
    useEffect(function() {
        var cachedCategoryId = sessionStorage.getItem('gallery.category');
        if (cachedCategoryId) {
            var categoryId = parseInt(cachedCategoryId);
            var category = categories.find(function(c) {
                return c.id === categoryId;
            });
            if (category) setSelectedCategory(category);
        }
    }, [
        categories
    ]);
    var updateCategory = useCallback(function(category) {
        setSelectedCategory(category);
        setQuery('');
        sessionStorage.setItem('gallery.category', category.id.toString());
        scrollIntoView(containerRef.current, {
            scrollMode: 'if-needed',
            behavior: 'smooth',
            block: 'start'
        });
    }, []);
    var onQueryChange = useCallback(function(ev) {
        setQuery(ev.target.value);
    }, []);
    var getItem = useCallback(function(id) {
        var numId = parseInt(id.substring(2));
        return id.startsWith('i-') ? images.get(numId) : groups.get(numId);
    }, [
        groups,
        images
    ]);
    var filteredItems = useDebouncedMemo(function() {
        return selectedCategory.items.map(function(id) {
            return getItem(id);
        }).filter(function(item) {
            var ref, ref2;
            var q = query.toLowerCase().trim();
            return item.name.toLowerCase().includes(q) || ((ref = item.location) === null || ref === void 0 ? void 0 : ref.name.toLowerCase().includes(q)) || ((ref2 = item.tags) === null || ref2 === void 0 ? void 0 : ref2.map(function(t) {
                return t.name;
            }).join('').toLowerCase().includes(q));
        });
    }, [
        query,
        selectedCategory
    ], 100);
    return /*#__PURE__*/ _jsxs(Layout, {
        title: 'Gallery',
        fullWidth: true,
        children: [
            /*#__PURE__*/ _jsx("section", {
                className: styles.categories,
                children: categories.map(function(category) {
                    return /*#__PURE__*/ _jsx(CategoryCard, {
                        category: category,
                        thumbnail: images.get(category.thumbnail),
                        isSelected: selectedCategory.id === category.id,
                        onSelect: updateCategory
                    }, category.id);
                })
            }),
            /*#__PURE__*/ _jsx("section", {
                className: styles.search,
                children: /*#__PURE__*/ _jsx("input", {
                    ref: containerRef,
                    value: query,
                    placeholder: '🔍 search images',
                    onChange: onQueryChange
                })
            }),
            /*#__PURE__*/ _jsx(Gallery, {
                imagesAndGroups: filteredItems
            }),
            /*#__PURE__*/ _jsx(ScrollTop, {})
        ]
    });
};
export var __N_SSG = true;
export default _withSuperJSONPage(Home);
